const mobileVh = () => {
	document.addEventListener('DOMContentLoaded', function () {
		function vhMobile() {
			const vh = window.innerHeight * 0.01
			document.documentElement.style.setProperty('--vh', +vh+'px')
		}
		window.addEventListener('resize', vhMobile)
		vhMobile()
	})
}

export default mobileVh
